<template>

    <div class="row margin-tb-50">

        <article class="wrap--sm">

            <header class="shop__header margin-b-100 center">

              <a class="logo logo__dark" href="/"></a>

            </header>

            <transition name="fade">

                <nav class="nav-shop margin-b-100" v-if="currentComponent !== 'invoice' && !isLoading && currentComponent !== 'error' && currentComponent !== 'payment'">

                  <ul>

                    <template v-for="(step, index) in steps">

                        <li v-if="step.menuName">

                            <a href="#" :class="{'selected':(step == steps[currentStep])}" v-if="step.loaded" @click.prevent="setStep(index)">{{step.menuName}}</a>

                            <a class="disabled" href="#" v-else @click.prevent="">{{step.menuName}}</a>

                        </li>

                    </template>

                  </ul>

                </nav>
            </transition>

            <transition name="fade" mode="out-in">

                <component :is="currentComponent"></component>

            </transition>

        </article>

    </div>

</template>

<script>
    //import { getCurrentStep, isLoading} from './../vuex/getters';
    //import { setProduct,setStep } from './../vuex/actions';
    import { mapGetters, mapActions } from 'vuex';
    import Details from './steps/details.vue';
    import Information from './steps/information.vue';
    import Approve from './steps/approve.vue';
    import Payment from './steps/payment';
    import Invoice from './steps/invoice.vue';
    import CardError from './steps/error.vue';
    export default {
        name: 'Order',
        data: function () {
            return {
               steps: [
                   {
                       component: 'orderdetails',
                       menuName: 'Produkt',
                       loaded:false
                   },
                   {
                       component: 'information',
                       menuName: 'Oplysninger',
                       loaded:false
                   },
                   {
                       component: 'approve',
                       menuName: 'Bekræftelse',
                       loaded:false
                   },
                   {
                       component: 'payment',
                       loaded:false
                   },
                   {
                       component: 'invoice',
                       loaded:false
                   },
                   {
                       component: 'error',
                       loaded:false
                   }
                ],
            }
        },
        props: ['product'],
        components:{
            orderdetails:Details,
            information:Information,
            approve:Approve,
            payment:Payment,
            invoice:Invoice,
            error:CardError
        },
        computed:{
          ...mapGetters({
            currentStep: 'getCurrentStep',
            isLoading:'isLoading'
          }),
            currentComponent(){
                  this.steps[this.currentStep].loaded = true;

                  if(this.currentStep == 6)
                  {
                      this.steps[3].loaded = false;
                  }

                  return this.steps[this.currentStep].component;
             }
        },
        methods: {
            ...mapActions([
                'setProduct',
                'setStep',
                'setInformation'
            ])
        },
        created(){
            if(!this.product){
                console.log('no product');
            }

            this.setProduct(this.product);
            this.setInformation({
                firstname:'',
                lastname:'',
                address:'',
                zipcode:'',
                city:'',
                email:'',
                phone:''
            });
        }
    }
</script>
